<script setup>
import {computed} from "vue";
import Card from "@/Components/Card.vue";

/**
 * Текстовый блок страницы лота.
 *
 * До 13.08.2026 страница лота состояла из шапки и карточек объявлений — ни одного предложения
 * текста, при том что адресуется она коммерческими запросами вида «купить аккаунт роблокс»
 * (19 166 показов в месяц). Поле `lots.description` при этом существовало, было `fillable`, лежало
 * в `$visible` и доезжало до фронта внутри `product.lots_active` — его просто никто не рисовал.
 *
 * Поле редактируется в админке как Textarea (`LotResource`), то есть это простой текст, а не HTML.
 * Поэтому здесь `v-text` по абзацам, а не `v-html`: разметку сюда всё равно никто не вводит, а
 * `v-html` открыл бы вставку скриптов из админки без единой причины.
 *
 * Бюджет длины. Трафик мобильный, и блок стоит выше списка объявлений: замерено на 390×844, что
 * 280 символов в двух абзацах занимают 146 px. Это потолок — два коротких абзаца. Длинный текст
 * здесь уводит первое объявление ещё дальше за первый экран, где до него и так стоят виджет чата,
 * шапка, чипсы лотов и блок фильтров.
 */
const props = defineProps({
    lot: {type: Object, default: null},
})

// Пустая строка разделяет абзацы — единственная разметка, которую даёт Textarea.
const paragraphs = computed(() => {
    const text = props.lot?.description

    if (typeof text !== 'string') {
        return []
    }

    return text
        .split(/\n\s*\n/)
        .map(part => part.trim())
        .filter(Boolean)
})
</script>

<template>
    <Card v-if="paragraphs.length" class="px-2.5 py-3 sm:px-4">
        <div class="flex flex-col gap-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            <p v-for="(paragraph, index) in paragraphs" :key="index">{{ paragraph }}</p>
        </div>
    </Card>
</template>
